// Every roster/timesheet time in Visitex is Australia/Sydney, regardless of the device's timezone.
export const SYD_TZ = 'Australia/Sydney';

const partsFmt = new Intl.DateTimeFormat('en-AU', {
  timeZone: SYD_TZ, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit',
});

function sydParts(date) {
  const p = {};
  for (const { type, value } of partsFmt.formatToParts(date)) p[type] = value;
  return { y: +p.year, m: +p.month, d: +p.day, h: +p.hour % 24, min: +p.minute };
}

// Sydney's UTC offset (minutes) at a given instant
function sydOffsetMinutes(date) {
  const { y, m, d, h, min } = sydParts(date);
  return (Date.UTC(y, m - 1, d, h, min) - Math.floor(date.getTime() / 60000) * 60000) / 60000;
}

const pad = (n) => String(n).padStart(2, '0');

/** UTC ISO (or Date) → "YYYY-MM-DDTHH:MM" wall-clock in Sydney, for <input type="datetime-local"> */
export function utcToSydLocalInput(iso) {
  const date = iso instanceof Date ? iso : new Date(iso);
  if (isNaN(date)) return '';
  const { y, m, d, h, min } = sydParts(date);
  return `${y}-${pad(m)}-${pad(d)}T${pad(h)}:${pad(min)}`;
}

/** "YYYY-MM-DDTHH:MM" typed as Sydney wall-clock → UTC ISO string (.000Z) */
export function sydLocalInputToUtcIso(local) {
  if (!local) return null;
  const [datePart, timePart = '00:00'] = local.split('T');
  const [y, m, d] = datePart.split('-').map(Number);
  const [h, min] = timePart.split(':').map(Number);
  const guess = Date.UTC(y, m - 1, d, h, min);
  let utc = guess - sydOffsetMinutes(new Date(guess)) * 60000;
  utc = guess - sydOffsetMinutes(new Date(utc)) * 60000; // second pass settles DST edges
  return new Date(utc).toISOString();
}

/** UTC ISO → "YYYY-MM-DD" calendar date in Sydney */
export function sydDateKey(iso) {
  const date = iso instanceof Date ? iso : new Date(iso);
  if (isNaN(date)) return '';
  const { y, m, d } = sydParts(date);
  return `${y}-${pad(m)}-${pad(d)}`;
}

export const sydTodayKey = () => sydDateKey(new Date());
